import {collection, getAggregateFromServer, query, sum} from 'firebase/firestore'
import {fire} from "../../../fire";

export const contarPropiedadSumaWheres = ({coleccion, propiedad, wheres = []}) => {
    // 0 es enero


    let col = collection(fire, coleccion)
    const q = query(col, ...wheres);


    return new Promise(resolve => {
        getAggregateFromServer(q, {total: sum(propiedad)}).then((dox) => {
            return resolve(dox.data().total)
        }).catch((err) => {
            console.log(err.message)
            return resolve(0)
        })
    })


}